// Клиент для `/api/public/casings` — каталог обсадки публичного юзера.
// Тонкая обёртка над generic `crudClient` (см. crudClient.ts) — весь
// fetch-boilerplate там, здесь только типы и базовый путь.
// Типы — единый источник правды: ts-rs-генерация из
// `crates/backend/web_api_types/src/casing.rs` (alias @webtypes, см.
// vite.config.ts / tsconfig.app.json). Регенерация — `cargo test -p web_api_types`.
//
// Все размеры — SI: метры/кПа/кг·м⁻³ (ровно как на сервере).

import type { CasingDto } from '@webtypes/CasingDto'
import type { CreateCasingBody } from '@webtypes/CreateCasingBody'
import type { UpdateCasingBody } from '@webtypes/UpdateCasingBody'
import { crudClient } from './crudClient'

export type { CasingDto, CreateCasingBody, UpdateCasingBody }
// 409 = casing используется в каком-то public_state (FK ON DELETE RESTRICT);
// страница ловит его `instanceof InUseError`.
export { InUseError } from './crudClient'

const client = crudClient<CasingDto, CreateCasingBody, UpdateCasingBody>(
  '/api/public/casings',
  'Обсадка используется в state — удалить нельзя',
)

export const listCasings = client.list
export const createCasing = client.create
export const updateCasing = client.update
export const deleteCasing = client.remove
